var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActioms03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#7a934f",
    d: "M14 7A7 7 0 1 1 0 7a7 7 0 0 1 14 0zM8.697 2.463c-.348.348-.37.893-.049 1.214L9.813 4.84c.321.321.865.3 1.214-.048.348-.35.37-.892.048-1.214L9.91 2.414a.787.787 0 0 0-.555-.227.923.923 0 0 0-.658.276zM3.65 7.51l2.33 2.33 3.785-3.785-2.33-2.329zm-1.22 3.514l3.073-.616L3.046 7.95z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActioms03);
export default __webpack_public_path__ + "static/media/actioms03.c9c4d74dcf327200aea766e04ebfa6a1.svg";
export { ForwardRef as ReactComponent };